const LoginOne = () => import('@/modules/session/views/LoginOne')
const ForgotPassword = () => import('@/modules/session/views/ForgotPassword')
const ResetPassword = () => import('@/modules/session/views/ResetPassword')
const CreateAccount = () => import('@/modules/session/views/CreateAccount')
const AccountActivation = () => import('@/modules/session/views/AccountActivation')
const VerificationCode = () => import('@/modules/session/views/VerificationCode')
const PhoneRegistration= () => import('@/modules/session/views/PhoneRegistration')

const routes = [
  {
    path: '/sesion/login',
    name: 'login',
    component: LoginOne,
    meta: {
      title: 'message.login',
      breadcrumbb: null
    }
  },
  {
    path: '/sesion/account-activation/:token/:email',
    name: 'account-activation',
    component: AccountActivation,
    meta: {
      title: 'Account Activation',
      breadcrumbb: null
    }
  },
  {
    path: '/sesion/create-account',
    name: 'create-account',
    component: CreateAccount,
    meta: {
      title: 'Create New Account',
      breadcrumbb: null
    }
  },
  {
    path: '/sesion/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: {
      title: 'Forgot my Password',
      breadcrumb: null
    }
  },
  {
    path: '/sesion/reset-password/:token/:email',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      title: 'Reset Password',
      breadcrumb: null
    }
  },
  {
    path: '/sesion/verification-code/:temp_token/:email',
    name: 'verification-code',
    component: VerificationCode,
    meta: {
      title: 'Verification Code',
      breadcrumb: null
    }
  },
  {
    path: '/sesion/phone-registration/:temp_token/:email',
    name: 'phone-registration',
    component: PhoneRegistration,
    meta: {
      title: 'Phone Number Registration',
      breadcrumb: null
    }
  }
]

export default routes
